import UIKitThemePkg from 'ux1-ui-kit-theme/package.json';

export const serverProps = window._props || { apsContext: {} };

export const baseApiUrl = '/aps/2';

export const baseFWUrl = `${baseApiUrl}/ui/runtime/ux1framework`;

export const stylesPath = `${baseFWUrl}/styles`;

export const themePath = `${stylesPath}/theme`;

export const imagesPath = `${themePath}/lib/images`;

export const spriteStyleUrl = `${themePath}/lib/sprite/view/sprite.css?version=${UIKitThemePkg.version}`;

export const spriteDefinitionsUrl = `${themePath}/lib/sprite/symbol/svg/sprite.symbol.svg?version=${UIKitThemePkg.version}`;

export const spriteSheetUrl = `${stylesPath}/theme/lib/sprite/view/svg/sprite.view.svg?version=${UIKitThemePkg.version}`;

const uiRuntimeVersion = serverProps.uiRuntimeVersion || '';

export const defaultStyleSheetsURLs = [
	`${stylesPath}/ui-kit/dist/UX1UIKit.css?${uiRuntimeVersion}`,
	`${themePath}/lib/index.css?${uiRuntimeVersion}`
];

export const logosPath = '/webgate/static/skins/v3/images/logos/';
